import * as Yup from 'yup'

const SignupSchema = Yup.object().shape({
    firstName: Yup.string().required('Required'),
    lastName: Yup.string().required('Required'),
    email: Yup.string().email('Invalid email').required('Required'),
    userName: Yup.string().required('Required'),
    password: Yup.string().required('Required'),
    confirmPassword: Yup.string()
        .oneOf([Yup.ref('password')], 'Passwords must match')
        .required('Required'),
    phoneNumber: Yup.string().required('Required'),
})
const LoginSchema = Yup.object().shape({
    email: Yup.string().email('Invalid email').required('Required'),
    password: Yup.string().required('Required'),
})
const ForgotSchema = Yup.object().shape({
    email: Yup.string()
        .email('Invalid email')
        .required('Required')
        .test(
            'valid-email',
            'Invalid email format',
            (value: string | undefined) => {
                if (!value) return true // Allow empty values (handled by .required())
                const [, domain] = value.split('@')
                return !!(domain && domain.includes('.'))
            }
        ),
})

const ResetPasswordSchema = Yup.object().shape({
    password: Yup.string()
        .required('Required')
        .matches(
            /^(?=.*[A-Z])(?=.*[!@#\$%\^&\*])(?=.{8,})/,
            'Must contain at least 8 characters, including one uppercase letter and one special character.'
        ),
    confirmPassword: Yup.string()
        .oneOf(
            [Yup.ref('password')],
            'Password and Confirm Password must match'
        )
        .required('Required'),
})

const addBrandSchema = Yup.object().shape({
    name: Yup.string().required('Required'),
    description: Yup.string().required('Required'),
})
export {
    SignupSchema,
    LoginSchema,
    ForgotSchema,
    ResetPasswordSchema,
    addBrandSchema,
}
